<template>
  <div v-if="start">
    <div class="lg:w-3/4">
      <vx-card class="lg:p-8 w-full mb-6">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Название организации:"
              name="name"
              v-model="currentSettings.name"
              v-validate="'required'"
              :class="isEditedClass(currentSettings.name, settings.name)" />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Адрес (Город):"
              name="city"
              v-model="currentSettings.city"
              v-validate="'required'"
              :class="isEditedClass(currentSettings.city, settings.city)" />
            <span class="text-danger text-sm" v-show="errors.has('city')">{{ errors.first('city') }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <div class="vs-input--label">Часовой пояс:</div>
            <v-select
              label="text"
              v-model="currentSettings.timezone"
              :clearable="false"
              :reduce="option => option.value"
              :options="timezoneOptions"
              :class="isEditedClass(currentSettings.timezone, settings.timezone)"
            />
          </div>
        </div>
      </vx-card>

      <vx-card class="lg:p-8 w-full mb-6">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-10 lg:pr-20" v-for="(day, index) in currentSettings.daysOfWeek" :key="day.dow">
            <div>
              <div class="vx-card__title mb-4">
                <h4 class="mb-4">{{ day.day_name }}</h4>
              </div>
              <vs-checkbox
                v-model="day.is_working_day"
                class="mb-4"
                :class="isEditedClass(day.is_working_day, settings.daysOfWeek[index].is_working_day)">
                <b>Рабочие дни</b>
              </vs-checkbox>
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div class="vs-input--label">Начало рабочего дня:</div>
                  <v-select
                    label="text"
                    :clearable="false"
                    :reduce="option => option.value"
                    v-model="day.starts_at"
                    :options="timesOptions"
                    :class="isEditedClass(day.starts_at, settings.daysOfWeek[index].starts_at)"
                  />
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div class="vs-input--label">Конец рабочего дня:</div>
                  <v-select
                    label="text"
                    :clearable="false"
                    :reduce="option => option.value"
                    v-model="day.ends_at"
                    :options="timesOptions"
                    :class="isEditedClass(day.ends_at, settings.daysOfWeek[index].ends_at)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>

      <SaveBlock
        :show="hasChanges"
        :loading="loading"
        @accept="saveSettings"
        @cancel="cancelChanges"
      />
    </div>
  </div>
</template>

<script>
import { copyObject, compareObjects, isEditedClass } from '../../helpers/helpers'

import Company from '../../api/http/models/Company'
import { mapGetters, mapActions } from 'vuex'
import { timezoneOptions, timesOptions } from '../../data/options'

export default {
  data () {
    return {
      start: false,
      loading: false,
      currentSettings: {},
      timezoneOptions,
      timesOptions,
      hasChanges: false,
      settings: {
        name: '',
        city: '',
        timezone: 3,
        daysOfWeek: []
      }
    }
  },
  computed: mapGetters(['authUserCompany']),
  watch: {
    currentSettings: {
      deep: true,
      handler (newValue) {
        this.hasChanges = !compareObjects(newValue, this.settings)
      }
    }
  },
  async created () {
    const company = await Company.getCompany(this.authUserCompany.slug)
    const daysOfWeek = await Company.getDaysOfWeek(this.authUserCompany.slug)

    this.settings.name = company.data.settings ? company.data.settings.name : ''
    this.settings.city = company.data.settings ? company.data.settings.city : ''
    this.settings.timezone = company.data.timezone
    this.settings.daysOfWeek = daysOfWeek.data

    await this.copySettings()

    this.start = true
  },
  methods: {
    ...mapActions(['updateCompany']),
    isEditedClass,
    copySettings () {
      this.currentSettings = copyObject(this.settings)
    },
    cancelChanges () {
      this.copySettings()
    },
    async saveSettings () {
      const validate = await this.$validator.validateAll()

      if (validate) {
        const allResults = []

        this.loading = true

        // Обновление настроек компании
        const updatedCompany = await Company.updateCompany(this.authUserCompany.slug, {
          timezone: this.currentSettings.timezone,
          name: this.currentSettings.name,
          city: this.currentSettings.city
        })


        if (updatedCompany.status === 'success') {
          this.settings.timezone = updatedCompany.data.timezone
          this.settings.name = updatedCompany.data.settings.name
          this.settings.city = updatedCompany.data.settings.city
          this.updateCompany(updatedCompany.data)
          allResults.push(true)
        } else {
          allResults.push(false)
        }

        // Обновление всех дней недели
        for (const [index, day] of this.currentSettings.daysOfWeek.entries()) {
          await (async () => {
            const updatedDay = await Company.updateDayOfWeek(this.authUserCompany.slug, day.dow, {
              is_working_day: day.is_working_day,
              starts_at: day.starts_at,
              ends_at: day.ends_at
            })

            if (updatedDay.status === 'success') {
              this.settings.daysOfWeek[index] = this.currentSettings.daysOfWeek[index]
              allResults.push(true)
            } else {
              allResults.push(false)
            }
          })()
        }

        if (!allResults.includes(false)) {
          this.copySettings()
          this.$vs.notify({
            color: 'success',
            title: 'Все настройки успешно обновлены',
            text: ''
          })
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Произошла ошибка',
            text: ''
          })
        }
        this.loading = false
      }
    }
  }
}
</script>
